module.exports = __webpack_public_path__ + "img/CompletedGreen.085723e7.png";